import React from 'react';
import { useEffect } from 'react';
import { FormGroup, Label, Input, Form, Row, Col } from 'reactstrap';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { unregister } from "../Interceptor.js";

import Spinner from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';

const useStyles = makeStyles((theme) => ({
    listItem: {
        padding: theme.spacing(1, 0),
    },
    total: {
        fontWeight: 700,
    },
    title: {
        marginTop: theme.spacing(2),
    },
}));

var detalle = [];
var id = 0;
var total = 0;
var totalDedu = 0;
var num = 0;

export default function General() {

    const classes = useStyles();

    const [lineas, setLineas] = React.useState(0);
    const [totaldef, setTotaldef] = React.useState(0);

    const [loading, setLoading] = React.useState(false);

    useEffect(() => {
        
        setTotaldef(0);
        detalle = [];
        total = 0;
        totalDedu = 0;
        num = 0;
        id = localStorage.getItem("idEmpleado");
        getDetalle(id);
    }, []);

    const getDetalle = (idEmpleado) => {
        setLoading(true);
        console.log("obteniendoDetalle");
        var myHeaders = new Headers();

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        };

        var mes = localStorage.getItem("mes");
        var anio = localStorage.getItem("anio");

        var url = "./api/Novedad/TraerNovedadxEmpleado?iIdEmpleado=" + idEmpleado + "&shMes=" + mes + "&iAno=" + anio;
        fetch(url, requestOptions)
            .then(response => response.json())
            .then(result => {
                console.log(result);
                var novedades = result.basePresentationList;
                //setNovedades(result.basePresentationList);
                for (var i = 0; i < novedades.length; i++) {
                    var nov = {
                        "Cantidad": novedades[i].Cantidad,
                        "CodigoProducto": novedades[i].Id_producto,
                        "DescripcionProducto": novedades[i].ProductoNombre,
                        "PorImpuesto2": novedades[i].PorcentajeImpto,
                        "ValorUnitario": novedades[i].ValorUnitario,
                        "TipoNovedad": novedades[i].TipoNovedad
                    }
                    detalle[i] = nov;
                    if (novedades[i].CodigoCategoria == 5) {
                        total = total + novedades[i].ValorUnitario;
                    } else {
                        totalDedu = totalDedu + novedades[i].ValorUnitario;
                    }
                    console.log(detalle);
                }
                num = total - totalDedu;
                setTotaldef(num);
                setLineas(detalle.length);
                localStorage.setItem("totalDef", num);
                setLoading(false);
            })
            .catch(error => {
                console.log('error', error);
                setLoading(false);});
    }

    var formatter = formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'COP',

        // These options are needed to round to whole numbers if that's what you want.
        //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
        //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
    });

    return (
        <React.Fragment>

            <Dialog open={loading} >
                <div style={{ textAlign: "center", margin: "15px" }}>
                    {loading && <Spinner color="secondary" />}
                    <h3 style={{ fontSize: '15px', fontFamily: 'Hammersmith One' }}>Cargando...</h3>
                </div>
            </Dialog>

            <Row style={{margin: "30px"}}>
                <Col md="2">
                </Col>
                <Col md="8">
                
            <Typography variant="h6" gutterBottom>
                Totales
      </Typography>
            <List disablePadding>
                <ListItem className={classes.listItem}>
                    <ListItemText primary="Total de Lineas:" />
                            <Typography variant="body2">
                                {lineas}
                    </Typography>
                </ListItem>
                <ListItem className={classes.listItem}>
                    <ListItemText primary="Subtotal:" />
                    <Typography variant="body2">
                                {formatter.format(totaldef)}
                    </Typography>
                </ListItem>
                        {/*  <ListItem className={classes.listItem}>
                    <ListItemText primary="Total IVA:" />
                    <Typography variant="body2">
                       123
                    </Typography>
                </ListItem>
                <ListItem className={classes.listItem}>
                    <ListItemText primary="Total de Ipoconsumo Nacional:" />
                    <Typography variant="body2">
                        123
                    </Typography>
                </ListItem>
                <ListItem className={classes.listItem}>
                    <ListItemText primary="Base + Cargos - Descuentos:" />
                    <Typography variant="body2">
                        23
                    </Typography>
                </ListItem>
                <ListItem className={classes.listItem}>
                    <ListItemText primary="Base + Cargos - Descuentos + Impuestos:" />
                    <Typography variant="body2">
                       123
                    </Typography>
                </ListItem>*/}
                <ListItem className={classes.listItem}>
                    <ListItemText primary="Total a pagar:" />
                    <Typography variant="subtitle1" className={classes.total}>
                                {formatter.format(totaldef)}
                    </Typography>
                </ListItem>

            </List>
           
                <Grid item container direction="column" xs={12} sm={6}>
                    {/*<Typography variant="h6" gutterBottom className={classes.title}>
            Payment details
          </Typography>
          <Grid container>
            {payments.map((payment) => (
              <React.Fragment key={payment.name}>
                <Grid item xs={6}>
                  <Typography gutterBottom>{payment.name}</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography gutterBottom>{payment.detail}</Typography>
                </Grid>
              </React.Fragment>
            ))}
            </Grid>*/}
                    </Grid>
                </Col>
                <Col md="2">
                </Col>
                </Row>
            
        </React.Fragment>
    );
}